<template>
    <address-list scope="event_organizers"></address-list>
</template>

<script>
import AddressList from '@/components/address/List.vue';

export default {
    name: 'EventOrganizersList',

    components: {
        AddressList,
    },
};
</script>
